import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Gift, CheckCircle2 } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { formatAUD } from "@/lib/media";
import api from "@/lib/api";

export default function GiftCardSuccess() {
  useSeo("Gift Card", "Your Happy Bulldog Co. gift card.");
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("loading");
  const [card, setCard] = useState(null);

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/gift-cards/status/${sessionId}`);
        setCard(data);
        if (data.status === "active") { setState("active"); return; }
      } catch (e) { console.warn("Gift card status check failed, retrying", e); }
      if (++tries < 8) setTimeout(poll, 2000); else setState("pending");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="max-w-xl mx-auto px-4 py-20 text-center">
      {state === "active" && card ? (
        <>
          <CheckCircle2 className="w-16 h-16 text-[#7ED957] mx-auto" />
          <h1 className="font-display font-extrabold text-3xl text-[#19324A] mt-4">Gift card sent! 🐾</h1>
          <p className="text-[#19324A]/60 mt-2">We've emailed the code to {card.recipient_email} and a copy to you.</p>
          <div className="bg-gradient-to-br from-[#A78BFA] to-[#4CC9F0] rounded-3xl p-8 text-white soft-shadow mt-8">
            <p className="text-white/80 text-sm">Value</p>
            <p className="font-display font-extrabold text-4xl">{formatAUD(card.amount)}</p>
            <p className="text-white/80 text-sm mt-4">Code</p>
            <p className="font-display font-extrabold text-2xl tracking-widest" data-testid="gift-success-code">{card.code}</p>
          </div>
          <Link to="/shop" className="btn-pink mt-8 inline-flex">Keep Shopping</Link>
        </>
      ) : state === "error" ? (
        <>
          <h1 className="font-display font-extrabold text-2xl text-[#19324A]">Something went wrong.</h1>
          <Link to="/gift-cards" className="btn-outline mt-6 inline-flex">Back to gift cards</Link>
        </>
      ) : (
        <>
          <Gift className="w-16 h-16 text-[#A78BFA] mx-auto animate-pulse" />
          <h1 className="font-display font-extrabold text-2xl text-[#19324A] mt-4">Finishing up your gift…</h1>
          <p className="text-[#19324A]/60 mt-2">This only takes a moment. We'll email the code shortly.</p>
        </>
      )}
    </div>
  );
}
